import { filterFromUrl } from '../lib/lib-util';
import { localCacheGet, session } from '@ekuaibao/session-info';
import { app } from '@ekuaibao/whispered';
import { Fetch } from '@ekuaibao/fetch';
import { pageViewCacheKey } from '@ekuaibao/lib/lib/help';
import { trackFMP } from '../lib/utils';
var _firstScreenRoute = '';
var _firstScreenIntent = createFirstScreenIntent('', 'manual');
export function getFirstScreenRoute() {
    return _firstScreenRoute;
}
export function getFirstScreenIntent() {
    return _firstScreenIntent;
}
export function setFirstScreenRoute(route) {
    _firstScreenRoute = route;
    setFirstScreenIntent(createFirstScreenIntent(route, 'manual'));
}
export function setFirstScreenIntent(intent) {
    _firstScreenIntent = intent;
    window.__FIRST_SCREEN_INTENT__ = intent;
}
export function initRoute(_a) {
    var _b = (_a === void 0 ? {} : _a).noTrack, noTrack = _b === void 0 ? false : _b;
    var noPathCache = filterFromUrl('noPathCache');
    var locationHash = location.hash.slice(1);
    var blackList = ['/login', '/auth-check', '/selectEnterprise5', '/mc-error', '/shared-error'];
    var shouldNotRedirect = !!~blackList.indexOf(locationHash);
    if (shouldNotRedirect || noPathCache) {
        var route = locationHash || '/new-homepage';
        setFirstScreenIntent(createFirstScreenIntent(route, 'initRoute'));
        if (noPathCache) {
            !noTrack && trackFMP(route);
        }
        return;
    }
    if (!Fetch.ekbCorpId && (window.__PLANTFORM__ === 'APP' || window.__PLANTFORM__ === 'THIRDPARTY')) {
        initFetchEkbCorpId();
    }
    var _c = pageViewCacheKey(Fetch.ekbCorpId), beforePagePathKey = _c.beforePagePathKey, beforePageKeyAppId = _c.beforePageKeyAppId;
    var beforePage = decodeURIComponent(localCacheGet(beforePagePathKey, true));
    var beforePageAppId = decodeURIComponent(localCacheGet(beforePageKeyAppId, true));
    if (beforePageAppId) {
        Fetch.appId = beforePageAppId;
    }
    var cannotInit = !beforePage || !beforePage.startsWith('/');
    if (cannotInit) {
        window.__PLANTFORM__ === 'MC' ? (beforePage = '/mc-tenant-list') : (beforePage = '/new-homepage');
    }
    !noTrack && trackFMP(beforePage);
    _firstScreenRoute = beforePage;
    setFirstScreenIntent(createFirstScreenIntent(beforePage, 'initRoute'));
    app.useHistory({
        initialEntries: [beforePage],
        search: location.search.slice(1)
    });
}
function initFetchEkbCorpId() {
    var ekbCorpId = filterFromUrl('ekbCorpId');
    if (!ekbCorpId) {
        var userInfo = session.get('user');
        if (userInfo) {
            ekbCorpId = userInfo.corpId;
        }
    }
    if (ekbCorpId) {
        Fetch.ekbCorpId = ekbCorpId;
    }
}
function createFirstScreenIntent(route, source) {
    return {
        route: route,
        hash: route,
        search: location.search.slice(1),
        platform: window.__PLANTFORM__,
        source: source
    };
}
